module.exports = __webpack_public_path__ + "img/img_size_04.89b64803.png";